import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { isUndefinedOrNullOrEmpty } from '@psnb/services';
import { CreateAssetDialogViewModel } from './create-asset-dialog.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'nwt-create-asset-dialog',
  styleUrls: ['./create-asset-dialog.component.scss'],
  templateUrl: './create-asset-dialog.component.html'
})
export class CreateAssetDialogComponent implements OnInit {

  // Models
  public vm: CreateAssetDialogViewModel;

  private PsEditFieldsMetadata: { pageName: string; value: string }[] = [];

  // Constructor
  public constructor(
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<CreateAssetDialogComponent>,
    private router: Router
  ) { }

  // Angular lifecycle methods
  public ngOnInit(): void {
    this.vm = {
      assetType: [],
      errorMessage: '',
      selectedAssetType: ''
    };
    this.getFieldValue();
  }

  // Public methods
  public createAsset(selectedAssetType: string): void {
    if (isUndefinedOrNullOrEmpty(selectedAssetType?.trim())) {
      this.vm.errorMessage = 'Please select Asset Type before Proceed';
      this.cdr.detectChanges();
      return;
    }
    this.router.navigate(['/createasset'], { queryParams: { assetType: selectedAssetType } });
    this.dialogRef.close();
  }

  public onCloseDialog(): void {
    this.dialogRef.close();
  }

  // Private methods
  private getFieldValue(): void {
    this.PsEditFieldsMetadata = JSON.parse(localStorage.AllPsEditFieldsMetadata);
    let hasChanges: boolean = false;
    this.PsEditFieldsMetadata.forEach((itemData: { pageName: string; value: string }): void => {
      if (itemData.pageName === 'PSGenerator') {
        this.vm.assetType.push(itemData.value);
        hasChanges = true;
      }
    });
    if (hasChanges) {
      this.cdr.detectChanges();
    }
  }

  // TrackBy function for assetType
  public trackByAsset(index: number, assetTypeValue: string): string {
    return assetTypeValue;
  }
}
